import {
   LOG_OUT_BEGIN,
   LOG_OUT_SUCCESS,
   LOG_OUT_FAIL
  } from '../middleware/types'
  
  const initialState = {
    SUBMIT_loading: false,
    error: {},
    response:{}
  }
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case LOG_OUT_BEGIN:
        return {
          ...state,
          SUBMIT_loading: true
        }
      case LOG_OUT_SUCCESS:
          return {
              ...state,
              SUBMIT_loading: false,
              response: action.payload
            }
      case LOG_OUT_FAIL:
        return {
          ...state,
          SUBMIT_loading: false,
          error: action.payload
        }
      default:
        return state
    }
  }